import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import SalesforcePopup from '../../../../components/ProfilePage/CRMSelector/SalesforcePopup';
import { Api } from '../../../../typings/api';

interface SalesforcePopupContainerProps {
	isDisplayed: boolean;
	onCancel: () => void;
	onConfirm: (clientId: string, clientSecret: string) => void;
}

const mapStateToProps = (state: StoreState, ownProps: SalesforcePopupContainerProps) => {
	const {
		profile: { crmProviders, isLoading },
	} = state;

	const salesforceProvider = crmProviders
		? crmProviders.find(({ provider }) => provider === Api.CRMProviders.SALESFORCE)
		: undefined;

	return {
		...ownProps,
		clientId: salesforceProvider ? salesforceProvider.clientId : undefined,
		clientSecret: salesforceProvider ? salesforceProvider.clientSecret : undefined,
		isLoading,
	};
};

export default connect(mapStateToProps)(SalesforcePopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/CRMSelector/SalesforcePopup/index.tsx